import { Language, ReduxState, TextDirection } from 'interface';
import React, { /* useEffect, */ useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { __Phone2Props, __PhoneRef } from './phone.interface';
import './phone.style.scss';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { prsNum2Eng } from 'scripts/string';
import { extractTitle } from 'scripts/string';
export interface SLPPhoneRef extends __PhoneRef {}

const SLPPhoneInput: React.ForwardRefRenderFunction<__PhoneRef, ConnectedProps<typeof connector> & __Phone2Props> = (
    props: ConnectedProps<typeof connector> & __Phone2Props,
    ref,
) => {
    const lang = props.lang.utilities;
    const inputRef = useRef<HTMLInputElement>(null);
    const [error, setError] = useState<string>();
    // const [disabled, setDisabled] = useState<boolean>(false);
    const [active, setActive] = useState<boolean>(false);
    const immediateValue = useRef(props.defaultValue ? props.defaultValue : '');
    const [value, setValue] = useState<string>(immediateValue.current);
    const labelRef = useRef<HTMLLabelElement>(null);
    React.useImperativeHandle(ref, () => ({
        getValue: () => (inputRef.current ? inputRef.current.value : ''),
        setError: (text) => {
            setError(text);
        },
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    function onFocusHandler() {
        setActive(true);
    }
    function onblurHandler() {
        setActive(false);
    }
    function onClickHandler() {
        inputRef.current?.focus();
    }
    function onChangeHandler(e: any) {
        setError(undefined);
        const newValue: string = prsNum2Eng(e.target.value);
        if (newValue.length === 0 || newValue === '0' || newValue.match(/^\d*$/)) {
            immediateValue.current = newValue;
            setValue(immediateValue.current);
            if (props.onChange) props.onChange(immediateValue.current);
        }
    }
    function onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.charCode === 13 && props.onEnter) {
            e.preventDefault();
            e.currentTarget.blur();
            props.onEnter(immediateValue.current);
        }
    }

    // useEffect(() => {
    //     if (props.onChange) props.onChange(value);
    // }, [value]);

    return (
        <div
            onClick={onClickHandler}
            className={`ucheck-SLP-international-phone-2  ${props.dir === TextDirection.rtl ? 'rtl-text' : ''} ${
                value.length ? 'filled' : ''
            } ${active ? 'active' : ''} ${error ? 'error' : ''}`}
        >
            <div className="header-title" style={{ color: props.labelColor }}>
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </div>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className={`input-box  input-container ${props.endIcon ? 'has-end-icon' : ''} `}>
                <input
                    ref={inputRef}
                    value={value}
                    type="tel"
                    onFocus={onFocusHandler}
                    onBlur={onblurHandler}
                    onChange={onChangeHandler}
                    style={{ color: props.color }}
                    required={props.required}
                    onKeyPress={onKeyPress}
                    placeholder={props.formLang === Language.en ? lang.SLPPhonePHEn : lang.SLPPhonePH}
                    enterKeyHint="next"
                />
                {props.endIcon && (
                    <i className="material-icons" style={{ color: props.endIcon.color }}>
                        {props.endIcon.icon}
                    </i>
                )}
            </div>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPPhoneInput));
